import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const modulePersonnel = {
  namespaced: true,

  state: {
    name: 'personnel',
    personnel: [],
    statuses: [],
    statusesMap: {}
  },

  mutations,
  getters,
  actions
}

export default modulePersonnel;